import { ID_CHECK_ERROR_TYPES } from '@/common/utils/idCheckErrors'
import { ROOM_TYPES } from '@/common/utils/roomTypes'
import { canUserSign, FAILED_ID_CHECKS_LIMIT } from '@/common/utils/users'

export const getters = {
  isArchivingAdmin: state => state.profile?.isArchivingAdmin,
  isSubscriber: state => !!state.profile?.subscription,
  isSubPayingUser: state => state.profile?.isSubUser,
  isSubAdmin: state => state.profile?.isSubAdmin,
  isArchivingEnabled: state => !!state.profile?.subscription?.archivingEnabled,
  isArchivingHidden: state => !!state.profile?.subscription?.hideArchiveOption,
  isSearchFullTextEnabled: state => !!state.profile?.subscription?.searchFullTextEnabled,
  customizationEnabled: state => !!state?.profile?.subscription?.customizationEnabled,
  validationChecklistItemDeletionEnabled: state => !!state?.profile?.subscription?.validationChecklistItemDeletionEnabled,
  areNotificationsForcedOnRoomClose: state => !!state.profile?.subscription?.forceNotificationsWhenClosingRoom,
  failedIdChecks: state => state.profile?.failedIdChecks,
  isIdCheckPending: state => state.profile?.failedIdChecks === FAILED_ID_CHECKS_LIMIT,
  canCurrentUserSign: state => canUserSign(state.profile),
  canAccessSubscription: state => state.profile?.isSubAdmin || state.profile?.isSubBillingAdmin,
  iManageEnabled: state => !!state.profile?.subscription?.iManageEnabled,
  profileFullName: state => state.profile?.fullName,
  currentUserId: state => state.profile?.id,
  hasIdCheckErrorInfo: state => state.idCheckError && state.idCheckError.errorType === ID_CHECK_ERROR_TYPES.ERROR_TYPE_INFO,
  canCurrentUserCreateProject: (state, getters) => {
    return getters.roomTypes.findIndex(roomType =>
        roomType.type === ROOM_TYPES.PROJECT_UNLIMITED,
    ) !== -1
  },
  canCurrentUserCreateDataroom: (state, getters) => {
    return getters.roomTypes.findIndex(roomType =>
        roomType.type === ROOM_TYPES.DATAROOM || roomType.type === ROOM_TYPES.DATAROOM_UNLIMITED,
    ) !== -1
  },
  roomTypes: state => state.profile?.subscription?.roomTypes ?? [],
  canCreateDataroomUnlimited: (state, getters) => {
    return getters.roomTypes.findIndex(roomType => roomType.type === ROOM_TYPES.DATAROOM_UNLIMITED) !== -1
  },
  canCreateDataroomPayPerUse: (state, getters) => {
    return getters.roomTypes.findIndex(roomType => roomType.type === ROOM_TYPES.DATAROOM) !== -1
  },
  hasActiveDataroom: state => !!state.profile?.subscription?.hasActiveDR,
  // No data room room-type (PPD/DR) and no live data room -> eligible for the LP-only
  isLpOnlyWithoutDataroom: (state, getters) => !getters.canCurrentUserCreateDataroom && !getters.hasActiveDataroom,
  polyOfficeEnabled: state => state.profile?.subscription?.polyOfficeEnabled,
  isChecklistDetailed: state => !!state.profile?.isChecklistDetailed,
  isProtegeAskEnabled: state => !!state.profile?.subscription?.protegeAskEnabled,
  isProtegeAskDocEnabled: state => !!state.profile?.subscription?.protegeAskDocEnabled,
  isProtegeAskDocFreemiumEnabled: state => !!state.profile?.subscription?.protegeAskDocFreemiumEnabled,
  protegeAskDocConversationLimit: state => state.profile?.subscription?.protegeAskDoc?.conversationLimit ?? null,
  protegeAskDocMessagePerConversationLimit: state => state.profile?.subscription?.protegeAskDoc?.messagePerConversationLimit ?? null,
  documentRedactionAiEnabled: state => !!state.profile?.subscription?.documentRedactionAiEnabled,
}
